import { useMsal } from '@azure/msal-react';

import { RrHeroPage } from '@rr-crm/shared/components';

import { apiScopes } from './msalConfig';

/**
 * LOGIN-HERO — CRM pre-login (Team Access) surface.
 *
 * Rendered by `<UnauthenticatedTemplate>` in `main.tsx` when no MSAL
 * account is present. The "Sign in with Microsoft" CTA triggers the
 * SAME `loginRedirect` with the SAME `apiScopes` the app has always
 * used — this is purely the presentation layer in front of the
 * unchanged redirect flow (previously the redirect fired automatically
 * via `MsalAuthenticationTemplate`; now the user clicks the branded
 * CTA, then the identical redirect runs).
 *
 * Auth behavior is untouched: same instance, same scopes, same
 * redirect. Only the surface the user sees before the redirect changed.
 */
export function LoginHero(): JSX.Element {
  const { instance } = useMsal();

  const handleSignIn = () => {
    // Identical redirect + scopes as the prior MsalAuthenticationTemplate.
    instance.loginRedirect({ scopes: apiScopes }).catch(() => undefined);
  };

  return (
    <RrHeroPage
      productLabel="CRM"
      heading="Team Access"
      supporting="Sign in with your company account to access the CRM, manage deals, and track commission."
      cta={{
        label: 'Sign in',
        onClick: handleSignIn,
      }}
      footer="Access restricted to therightrole.com accounts only."
    />
  );
}
